module.exports = "/img/caret-left.svg?c9d648fcff23a1da9e73cc33ccc16049";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-left.svg
// module id = +Oi8
// module chunks = 75